import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

const api3001 = axios.create({
    baseURL: process.env.REACT_APP_API_3001_URL,
});

setupInterceptors(api3001);

export default api3001;
